import React, { useEffect, useState } from "react";
import { Switch, Route, useLocation, Link, Redirect } from "react-router-dom";

import { Layout, Menu, Button, Spin, Form } from 'antd';
import { PieChartOutlined, UserOutlined, LogoutOutlined, MenuOutlined, EditOutlined, ExportOutlined, ImportOutlined, TagsOutlined, GoldOutlined, RetweetOutlined, ToolOutlined } from '@ant-design/icons';
import antLocale_ptPT from 'antd/lib/locale/pt_PT';
import antLocale_enGB from 'antd/lib/locale/en_GB';

import { FormattedMessage, useIntl } from "react-intl";
import flatten from 'flat';

import classNames from 'classnames';

import _auth from '@netuno/auth-client';

import Core from './common/Core';

import LanguageSelect from './components/LanguageSelect';

import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import ReservedArea from './pages/ReservedArea';
import RecoveryPage from './pages/Recovery';
import Profile from './pages/Profile';
import NotFoundPage from './pages/NotFound';

import lang_en_GB from './lang/en_GB.json';
import lang_pt_PT from './lang/pt_PT.json';

import './common/Config';

import './styles/App.less';

const { Header, Content, Sider, Footer } = Layout;
const { SubMenu } = Menu;

const lang = {
  en_GB: lang_en_GB,
  pt_PT: lang_pt_PT
};

export default function App({onLanguageChange}) {

  const intl = useIntl();

  const location = useLocation();

  const [headerButtonMode, setHeaderButtonMode] = useState('login');
  const [collapsed, setCollapsed] = useState(false);
  const [sideMenuMobileMode, setSideMenuMobileMode] = useState(false);

  const [formLanguage] = Form.useForm();

  useEffect(() => {
    setHeaderButtonMode(location.pathname);
  }, [location]);

  function onLogout() {
    Core.info(null);
    _auth.logout();
  }

  function onCollapse() {
    setCollapsed(!collapsed);
  }

  function onLanguageSelectChange(value) {
    Core.changeLanguage(value);
    if (onLanguageChange) {
      onLanguageChange(value);
    }
  }

  return (
    <Layout className={'page ' + classNames({ 'auth ': _auth.isLogged() }) + classNames({ 'collapsed ': collapsed })}>
      {_auth.isLogged() &&
       <Sider
         onBreakpoint={mobile => {
           setSideMenuMobileMode(mobile);
         }}
         collapsedWidth={sideMenuMobileMode ? '0' : '80'}
         breakpoint={"md"}
         collapsible
         collapsed={collapsed}
         onCollapse={onCollapse}
         trigger={<MenuOutlined />}
         theme="light"
       >
         <div className="logo-container"><img alt="logo" src="/images/logo.png" /></div>
         { Core.info() == null ? <div className="menu-loading"><Spin /></div> :
           <Menu defaultSelectedKeys={['1']} mode="inline">
             <SubMenu key="1" icon={<TagsOutlined />} title="Marketplace">
               <Menu.Item key="1_1" icon={<GoldOutlined />}>
                 <Link to="/marketplace/waste"><FormattedMessage id="reserved-area.menu.marketplace.waste" /></Link>
               </Menu.Item>
               <Menu.Item key="1_2" icon={<RetweetOutlined />}>
                 <Link to="/marketplace/service"><FormattedMessage id="reserved-area.menu.marketplace.service" /></Link>
               </Menu.Item>
             </SubMenu>
             <Menu.Item key="2" icon={<ToolOutlined />}>
               <Link to="/construction/list"><FormattedMessage id="reserved-area.menu.construction" /></Link>
             </Menu.Item>
             { Core.info().profile_code === 'waste-management' &&
               <Menu.Item key="3" icon={<RetweetOutlined />}>
                 <Link to="/service"><FormattedMessage id="reserved-area.menu.service" /></Link>
               </Menu.Item> }
           </Menu>
         }
       </Sider>
      }
      <Layout>
        <Header className={classNames({ 'auth ': _auth.isLogged() }) + classNames({ 'collapsed ': collapsed })}>
          <>
            {!_auth.isLogged() && <Link to="/" className="logo-container"><img alt="logo" src="/images/logo.png" /></Link>}
          </>
          <div className="ant-layout-header-sider">
            { !_auth.isLogged() &&
              <Form form={formLanguage} style={{width: '230px'}} initialValues={{language: Core.currentLanguage()}}>
                <Form.Item label={intl.formatMessage({id: 'header.language'})} name="language" style={{marginBottom: '0'}}>
                  <LanguageSelect form={formLanguage} style={{width: '130px'}} onChange={onLanguageSelectChange} />
                </Form.Item>
              </Form> }
            {headerButtonMode === '/login' ?
             <Link to="/register">
               <Button type="primary"><FormattedMessage id="header.create-account" /></Button>
             </Link>
             : headerButtonMode === '/register' ?
             <Link to="/login">
               <Button type="primary"><FormattedMessage id="header.begin-session" /></Button>
             </Link>
             : _auth.isLogged() && 
             <div>
               <span className="user-header">{Core.info() ? Core.info().name : null}</span>
               <Menu mode="horizontal">
                 <SubMenu key={"profile"} className="profile-menu" icon={<UserOutlined />}>
                   <Menu.Item key="1">
                     <Link to="/profile">
                       <EditOutlined />
                       &nbsp;&nbsp;&nbsp;&nbsp;<FormattedMessage id="reserved-area.header.perfil" />
                     </Link>
                   </Menu.Item>
                   <Menu.Item key="2">
                     <Link to="/login">
                       <Button type="link" className="profile-button" onClick={onLogout} danger>
                         <LogoutOutlined />&nbsp;<FormattedMessage id="reserved-area.header.log-out" />
                       </Button>
                     </Link>
                   </Menu.Item>
                 </SubMenu>
               </Menu>
             </div>
            }
             <a href="https://cplusd-platform.pt/en/" target="_blank" style={{'margin-left':'10px'}}  >
               <Button type="primary">C+D project</Button>
             </a>
          </div>
        </Header>
        <Content className={classNames({ 'auth ': _auth.isLogged() })}>
          <Switch>
            <Route exact path="/">
              {_auth.isLogged() ?
               <Redirect to="/reserved-area" />
               :
               <Redirect to="/login" />
              }
            </Route>
            <Route path="/reserved-area" component={ReservedArea} />
            <Route path="/profile" component={Profile} />
            <Route path="/login" component={LoginPage} />
            <Route path="/marketplace/waste" component={ReservedArea} />
            <Route path="/marketplace/service" component={ReservedArea} />
            <Route path="/construction/list" component={ReservedArea} />
            <Route path="/construction/create" component={ReservedArea} />
            <Route path="/construction/edit/:uid" component={ReservedArea} />
            <Route path="/service" component={ReservedArea} />
            <Route path="/waste/to-produce" component={ReservedArea} />
            <Route path="/waste/to-consume" component={ReservedArea} />
            <Route path="/register" component={RegisterPage} />
            <Route path="/recovery" component={RecoveryPage} />
            <Route component={NotFoundPage} />
          </Switch>
        </Content>
        {!_auth.isLogged() &&
         <Footer>2022 © Instituto Superior Técnico, Universidade de Lisboa</Footer>
        }
      </Layout>
    </Layout>
  );
}
